import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

// Same key the Lex-Z dashboard uses for its collapse preference.
const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed';

function readSavedCollapsed(): boolean {
  try {
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    return saved !== null && JSON.parse(saved) === true;
  } catch {
    return false; // SSR / storage blocked / bad value
  }
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  constructor() { }

  // Desktop (>= 1024px): icon-only sidebar. Persisted.
  private sidebarCollapsed = new BehaviorSubject<boolean>(readSavedCollapsed());
  sidebarCollapsed$ = this.sidebarCollapsed.asObservable();

  // Tablet / mobile (< 1024px): off-canvas drawer. Not persisted.
  private mobileMenuOpen = new BehaviorSubject<boolean>(false);
  mobileMenuOpen$ = this.mobileMenuOpen.asObservable();

  toggleSidebar() {
    const next = !this.sidebarCollapsed.value;
    this.sidebarCollapsed.next(next);
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(next));
    } catch { /* ignore */ }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.next(!this.mobileMenuOpen.value);
  }

  closeMobileMenu() {
    if (this.mobileMenuOpen.value) {
      this.mobileMenuOpen.next(false);
    }
  }
}